/**
 * Localized copy for the "open shop is closed" state (brand flag
 * "Disable Open Shop" / `openShopEnabled: false` from useBrandSettings).
 * Hardcoded per brand like the rest of the storefront strings; keyed by the
 * API brand slug with an English fallback for unknown brands.
 */
export const CLOSED_SHOP_COPY = {
  clsdk: {
    title: 'Butikken er lukket lige nu',
    text: 'Beklager, butikken er lukket lige nu – men den åbner snart igen!',
    contactLabel: 'Kontakt os',
    faqLabel: 'Se FAQ',
  },
  clsse: {
    title: 'Butiken är stängd just nu',
    text: 'Tyvärr är butiken stängd just nu – men den öppnar snart igen!',
    contactLabel: 'Kontakta oss',
    faqLabel: 'Se FAQ',
  },
  abcse: {
    title: 'Butiken är stängd just nu',
    text: 'Tyvärr är butiken stängd just nu – men den öppnar snart igen!',
    contactLabel: 'Kontakta oss',
    faqLabel: 'Se FAQ',
  },
  clsfi: {
    title: 'Kauppa on nyt suljettu',
    text: 'Valitettavasti kauppa on suljettu juuri nyt – mutta se avautuu pian!',
    contactLabel: 'Ota yhteyttä',
    faqLabel: 'FAQ',
  },
  en: {
    title: 'This shop is closed right now',
    text: 'Sorry, this shop is closed now, but it will open soon!',
    contactLabel: 'Contact us',
    faqLabel: 'FAQ',
  },
};

export const closedShopCopyFor = (brandSlug) => CLOSED_SHOP_COPY[brandSlug] || CLOSED_SHOP_COPY.en;
